import { NextPageContext } from "next";

import {
  SET_DOMAIN_LOCATION,
  SetDomainCountryCodeAction,
} from "redux/reducers/config";
import { getCountryCodeHeader } from "utils/requestContext";

export const setDomainCountryCode = (
  ctx: NextPageContext
): SetDomainCountryCodeAction => ({
  countryCode: getCountryCodeHeader(ctx),
  type: SET_DOMAIN_LOCATION,
});
